import React, { useState } from 'react'
import { FaArrowUp, FaArrowDown } from "react-icons/fa6";

const FAQ2 = () => {

    const [faq, setFaq] = useState(false)
    const [faq2, setFaq2] = useState(false)
    const [faq3, setFaq3] = useState(false)
    const [faq4, setFaq4] = useState(false)
    const [faq5, setFaq5] = useState(false)
    const [faq6, setFaq6] = useState(false)

    const handleFaq1 = () => {
        setFaq(!faq)
        setFaq2(false)
        setFaq3(false)
        setFaq4(false)
        setFaq5(false)
        setFaq6(false)
    }
    const handleFaq2 = () => {
        setFaq(false)
        setFaq2(!faq2)
        setFaq3(false)
        setFaq4(false)
        setFaq5(false)
        setFaq6(false)
    }
    const handleFaq3 = () => {
        setFaq(false)
        setFaq2(false)
        setFaq3(!faq3)
        setFaq4(false)
        setFaq5(false)
        setFaq6(false)
    }
    const handleFaq4 = () => {
        setFaq(false)
        setFaq2(false)
        setFaq3(false)
        setFaq4(!faq4)
        setFaq5(false)
        setFaq6(false)
    }
    const handleFaq5 = () => {
        setFaq(false)
        setFaq2(false)
        setFaq3(false)
        setFaq4(false)
        setFaq5(!faq5)
        setFaq6(false)
    }
    const handleFaq6 = () => {
        setFaq(false)
        setFaq2(false)
        setFaq3(false)
        setFaq4(false)
        setFaq5(false)
        setFaq6(!faq6)
    }

    return (
        <div className='sm:py-36 py-20 sk:px-10 px-3 bg-[#ffffff] text-black text-center flex flex-col gap-2'>
            <p className='text-[32px] font-semibold'>Real talk FAQ</p>
            <p className='text-[#525154] font-normal mt-6'>Learn more at our Support page or send an email to <a className='underline' href="/" target="_blank" rel="noopener noreferrer">help@reccur.co.</a></p>
            <div className='flex flex-col gap-5 mt-16 max-w-[720px] 3xl:max-w-[1000px] w-full mx-auto text-start'>
                <div
                    onClick={handleFaq1}
                    className={`flex cursor-pointer justify-between gap-3 items-start rounded-[16px] sm:p-8 p-4 ${faq && 'bg-[#E8E1F5]'}`}
                >
                    <div>
                        <p className='text-[18px] 3xl:text-2xl font-medium '>Is this a real bank account?</p>
                        {faq && <p className='text-[14px] 3xl:text-[19px] mt-1 font-normal text-[#525154]'>Yes - issued under our EU/US banking partner; your name appears on every transfer.</p>}
                    </div>
                    {faq ? <FaArrowUp className='text-2xl' /> : <FaArrowDown />}

                </div>
                <div
                    onClick={handleFaq2}
                    className={`flex cursor-pointer justify-between gap-3 items-start rounded-[16px] sm:p-8 p-4 ${faq2 && 'bg-[#E8E1F5]'}`}
                >
                    <div>
                        <p className='text-[18px] 3xl:text-2xl font-medium '>Is USDC safe?</p>
                        {faq2 && <p className='text-[14px] 3xl:text-[19px] mt-1 font-normal text-[#525154]'>Fully-reserved stablecoin audited monthly; redeemable 1:1 for USD.</p>}
                    </div>
                    {faq2 ? <FaArrowUp className='text-2xl' /> : <FaArrowDown />}
                </div>
                <div
                    onClick={handleFaq3}
                    className={`flex cursor-pointer justify-between gap-3 items-start rounded-[16px] sm:p-8 p-4 ${faq3 && 'bg-[#E8E1F5]'}`}
                >
                    <div>
                        <p className='text-[18px] 3xl:text-2xl font-medium '>How long does withdrawal take?</p>
                        {faq3 && <p className='text-[14px] 3xl:text-[19px] mt-1 font-normal text-[#525154]'>30-90 seconds to NGN, GHS, KES, ZAR; next-day to GBP, USD, CAD, INR, PHP.</p>}
                    </div>
                    {faq3 ? <FaArrowUp className='text-2xl' /> : <FaArrowDown />}
                </div>
                <div
                    onClick={handleFaq4}
                    className={`flex cursor-pointer justify-between gap-3 items-start rounded-[16px] sm:p-8 p-4 ${faq4 && 'bg-[#E8E1F5]'}`}
                >
                    <div>
                        <p className='text-[18px] 3xl:text-2xl font-medium '>What if my client pays in another currency?</p>
                        {faq4 && <p className='text-[14px] 3xl:text-[19px] mt-1 font-normal text-[#525154]'>They wire USD or EUR; you receive the USDC equivalent automatically.</p>}
                    </div>
                    {faq4 ? <FaArrowUp className='text-2xl' /> : <FaArrowDown />}
                </div>
                <div
                    onClick={handleFaq5}
                    className={`flex cursor-pointer justify-between gap-3 items-start rounded-[16px] sm:p-8 p-4 ${faq5 && 'bg-[#E8E1F5]'}`}
                >
                    <div>
                        <p className='text-[18px] 3xl:text-2xl font-medium '>What are the fees exactly?</p>
                        {faq5 && <p className='text-[14px] 3xl:text-[19px] mt-1 font-normal text-[#525154]'>Inbound 0.8 %, outbound 0.55 % + small flat rail fee. We show the net you’ll receive before you confirm.</p>}
                    </div>
                    {faq5 ? <FaArrowUp className='text-2xl' /> : <FaArrowDown />}
                </div>
                <div
                    onClick={handleFaq6}
                    className={`flex cursor-pointer justify-between gap-3 items-start rounded-[16px] sm:p-8 p-4 ${faq6 && 'bg-[#E8E1F5]'}`}
                >
                    <div>
                        <p className='text-[18px] 3xl:text-2xl font-medium '>Do I need to touch crypto?</p>
                        {faq6 && <p className='text-[14px] 3xl:text-[19px] mt-1 font-normal text-[#525154]'>Only if you want, cash to fiat any time; or hold USDC if you prefer.</p>}
                    </div>
                    {faq6 ? <FaArrowUp className='text-2xl' /> : <FaArrowDown />}
                </div>
            </div>
        </div>
    )
}

export default FAQ2